import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { Historique } from './historique.model';
import { HistoriqueService } from './historique.service';

@Component({
    selector: 'jhi-historique-detail',
    templateUrl: './historique-detail.component.html'
})
export class HistoriqueDetailComponent implements OnInit, OnDestroy {

    historique: Historique;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private historiqueService: HistoriqueService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['historique']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.historiqueService.find(id).subscribe(historique => {
            this.historique = historique;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique-detail.component.ts